import { render, staticRenderFns } from "./table_data.vue?vue&type=template&id=cea6eec2&scoped=true&"
import script from "./table_data.vue?vue&type=script&lang=js&"
export * from "./table_data.vue?vue&type=script&lang=js&"
import style0 from "./table_data.vue?vue&type=style&index=0&id=cea6eec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea6eec2",
  null
  
)

export default component.exports